import React, { PropTypes } from 'react';
import { Map } from 'immutable';
import moment from 'moment';
import cx from './Review.scss';

import Avatar from 'components/Avatar';
import FormattedContent from 'components/FormattedContent';
import StarRating from 'components/StarRating';
import UserBadge from 'components/UserBadge';

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class Review extends React.Component {
  static propTypes = {
    review: PropTypes.object.isRequired,
    compact: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    compact: false,
  };

  render() {
    const { compact } = this.props;

    return compact ? this.renderCompact() : this.renderFull();
  }

  renderCompact() {
    const { review } = this.props;

    return (
      <div>
        <header className={cx('header')}>
          <UserBadge
            user={Map({
              id: review.get('user_id'),
              username: review.get('username'),
              avatar: review.get('avatar'),
            })}
            />
        </header>

        <FormattedContent>{`<p>${review.get('text')}</p>`}</FormattedContent>

        <footer className={cx('footer')}>
          <StarRating value={review.get('rating')} />

          <span className={cx('ratingText')}>
            Оценка {review.get('rating')}/5
          </span>
        </footer>
      </div>
    );
  }

  renderFull() {
    const { review } = this.props;

    return (
      <div className={cx('main')}>
        <div className={cx('avatar')}>
          <a href={`/user/${review.get('user_id')}`}>
            <Avatar size="m" user_id={review.get('user_id')} avatar={review.get('avatar')} />
          </a>
        </div>
        <div className={cx('body')}>
          <header className={cx('header')}>
            <a href={`/user/${review.get('user_id')}`} className={cx('username')}>
              {review.get('username')}
            </a>
            <span className={cx('ts')}>
              {moment(review.get('date')).calendar()}
            </span>
            <p className={cx('program')}>
              Отзыв к программе «{review.get('program_name')}»
            </p>
          </header>

          <FormattedContent>{`<p>${review.get('text')}</p>`}</FormattedContent>

          <footer className={cx('footer')}>
            <StarRating value={review.get('rating')} />

            <span className={cx('ratingText')}>
              Оценка {review.get('rating')}/5
            </span>
          </footer>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/react/components/Review/Review.js